
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface LogoUploadSectionProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
}

export function LogoUploadSection({ onFileChange, isLoading }: LogoUploadSectionProps) {
  return (
    <div>
      <Label htmlFor="logo">Organization Logo</Label>
      <div className="mt-1.5">
        <Input
          id="logo"
          type="file"
          accept="image/*"
          onChange={onFileChange}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
